import React from "react";
import { Add } from "@mui/icons-material";
import { Box, Button } from "@mui/material";
import { toast } from "react-toastify";

import FormDrawer from "components/Shared/FormDrawer";
import { useVehicleDetailContext } from "contexts/VehicleDetailContext";
import { useAddRealTimeTrackingMutation, useUpdateRealTimeTrackingMutation } from "store/services/realTimeTrackingApi";
import RealTimeTrackingForm from "../../RealTimeTracking/RealTimeTrackingComponents/RealTimeTrackingForm";
import VehicleLocationListByVehicle from "./VehicleLocationListByVehicle";



const VehicleLocationTab = () => {
  const [showTrackingForm, setShowTrackingForm] = React.useState(false);

  const [selectedTracking, setSelectedTracking] = React.useState(null);

  const { vehicleDetail } = useVehicleDetailContext();

  // RTK Query
  const [addRealTimeTracking, { isLoading: addingTracking }] = useAddRealTimeTrackingMutation();

  const [updateRealTimeTracking, { isLoading: updatingTracking }] = useUpdateRealTimeTrackingMutation();

  // Methods
  const handleCancelTracking = () => {
    setShowTrackingForm(false);
    setSelectedTracking(null);
  };

  const handleAddOrUpdateTracking = async (data) => {
    try {
      if (selectedTracking) {
        await updateRealTimeTracking({
          id: selectedTracking._id,
          vehicleId: vehicleDetail?._id,
          ...data,
        }).unwrap();
        toast.success("Tracking record updated successfully!");
      } else {
        await addRealTimeTracking({
          vehicleId: vehicleDetail?._id,
          ...data,
        }).unwrap();
        toast.success("Tracking record added successfully!");
      }
      handleCancelTracking();
    } catch (err) {
      toast.error(err?.data?.message ?? "Couldn't process tracking record!");
    }
  };

  return (
    <>
      <Box display="flex" justifyContent="end" padding={3}>
        {!showTrackingForm && (
          <Button
            startIcon={<Add />}
            variant="outlined"
            onClick={() => setShowTrackingForm(true)}
          >
            Add Tracking Record
          </Button>
        )}
      </Box>

      <VehicleLocationListByVehicle />

      <FormDrawer
        title="Vehicle Tracking Record"
        open={showTrackingForm}
        onClose={handleCancelTracking}
      >
        <RealTimeTrackingForm
          isBusy={addingTracking || updatingTracking}
          vehicleTracking={selectedTracking}
          onCancel={handleCancelTracking}
          onSubmit={handleAddOrUpdateTracking}
        />
      </FormDrawer>
    </>
  );
};

export default VehicleLocationTab;